<template>
	<v-select v-model="localStepId" :items="stepsOptions" item-text="node_title" item-value="uuid" placeholder="Choose step" outlined dense>
		<template v-slot:item="{ item }">
			<div class="step-select-container">
				<IntegrationIcon :integration-name="item.service_slug" />
				<div class="text-overflow-ellipsis">{{ item.node_title }}</div>
			</div>
		</template>
		<template v-slot:selection="{ item }">
			<div class="step-select-container">
				<IntegrationIcon :integration-name="item.service_slug" />
				<div class="text-overflow-ellipsis">{{ item.node_title }}</div>
			</div>
		</template>
	</v-select>
</template>

<script>
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { editNode } from '@/store/modules/selectedNode/getters';
import { useNodeAncestorIds } from '@/store/modules/workflowGraphs/getters';
import { getNodeByUuidForWorkflowVersion, getNode } from '@/store/modules/nodes/getters';

export default {
	name: 'StepSelector',
	components: {},
	props: {
		stepId: { type: String },
		isMultipleStep: { type: Boolean, default: false },
	},
	computed: {
		...mapGetters([
			'selectedNode/editNode',
			'actions/getAction',
			'apps/getService',
			'selectedWorkflow/nodesData',
			getNodeByUuidForWorkflowVersion.fullPath,
			getNode.fullPath,
		]),
		...mapGetters('widgetEditor', ['editField', 'widgetFields']),
		...mapGettersShorthand({ editNode, useNodeAncestorIds }),
		parentNodeIds() {
			if (!this.editNode) {
				return [];
			}
			return this.useNodeAncestorIds({ node: this.editNode });
		},
		stepsOptions() {
			const stepsOptions = [];
			this.parentNodeIds.forEach((nodeId) => {
				const node = cloneDeep(this['selectedWorkflow/nodesData'][nodeId]);
				const { action: actionId, service: serviceId, requires_auth: requiresAuth } = node;
				// we want to filter those who are not multiple
				const action = this['actions/getAction'](actionId);
				if (this.isMultipleStep && !(action && action.is_multiple)) {
					return;
				}

				if (!node.node_title) {
					if (requiresAuth) {
						if (actionId) {
							const action = this['actions/getAction'](actionId);
							if (action) {
								this.$set(node, 'node_title', action.title);
							}
						}
					}
					// node title is still empty
					if (!node.node_title) {
						if (serviceId) {
							const service = this['apps/getService'](serviceId);
							if (service) {
								this.$set(node, 'node_title', service.service_name);
							}
						}
					}
				}
				stepsOptions.push(node);
			});
			return stepsOptions.reverse();
		},
		localStepId: {
			get() {
				return this.stepId;
			},
			set(value) {
				this.$emit('update:stepId', value);
			},
		},
	},
};
</script>

<style scoped lang="scss">
::v-deep .step-select-container {
	display: flex;
	align-items: center;
	max-width: 100%;

	> div {
		margin: 0 10px 0 0;
	}
}
</style>
